import React from "react";
import { Close, Search } from "../../../assets/icons";

interface SearchInputProps {
    searchValue: string;
    onSearchChange: any;
    placeholder: string;
    width?:number
    bgColor?:string;
    onBlurChange?: any;
}

const SearchInput: React.FC<SearchInputProps> = ({
    bgColor,
    searchValue,
    width = 300,
    placeholder,
    onSearchChange,
    onBlurChange,
}) => {
    return (
        <div className={`flex py-[10px] px-[12px] items-center self-stretch gap-[8px] rounded-[8px] border-[1px] border-darkcolor-400 shadow-custom ${bgColor} hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500`} style={{width:width}}>
            <div className="flex items-center justify-center">
                <Search size={24} />
            </div>
            <div className="flex-1">
                <input
                    onChange={onSearchChange}
                    name="filter"
                    className="w-full text-neutral-25 border-0 p-0 shadow-none outline-none bg-transparent font-medium text-[16px]"
                    value={searchValue}
                    placeholder={placeholder}
                    autoComplete="off"
                    onBlur={onBlurChange}
                />
            </div>
            {searchValue && searchValue.length > 0 && (
                <div className="flex items-center justify-center ">
                    <Close onClick={() => onSearchChange("")} />
                </div>
            )}
        </div>
    );
};

export default SearchInput;
